import { render, staticRenderFns } from "./SchematicList.vue?vue&type=template&id=28daf439&scoped=true"
import script from "./SchematicList.vue?vue&type=script&lang=js"
export * from "./SchematicList.vue?vue&type=script&lang=js"
import style0 from "./SchematicList.vue?vue&type=style&index=0&id=28daf439&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28daf439",
  null
  
)

export default component.exports